import Cookies from 'js-cookie'

export default {
  auth: Cookies.get('x_sys_auth'),
}
